import { UpdateMessageOrigin, originBitRange } from '@canvas/protocol-types';

export const extractOriginValueFromBitFlags = (bitFlags: number) =>
  bitFlags & originBitRange;

export function isUndoRedo(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.UndoRedo;
}

export function isResizing(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.Resizing;
}

export function isCleanDocument(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.CleanDocument;
}

export function isAgent(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.Agent;
}

export function isBackendAgent(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.BackendAgent;
}

export function isLayoutShift(bitFlags: number) {
  return extractOriginValueFromBitFlags(bitFlags) === UpdateMessageOrigin.LayoutShift;
}
